import React from "react";
import Icon from "antd/lib/icon";

const Concept = props => {
  const columnStyle = {
    display: "flex",
    flexDirection: "column",
    marginBottom: "10px"
  };

  const blockText = {
    fontSize: "10pt",
    marginLeft: "5px"
  };

  return (
    <div>
      <p className="step-p"> 
        When adding a new block to the blockchain, the new block needs to meet these requirements.
      </p>

      <div style={columnStyle}>
        <div>
          <Icon type="plus"/>
          <span style={blockText}>Block index one greater than latest block index.</span>
        </div>
        <div>
          <Icon type="qrcode"/>
          <span style={blockText}>Block previous hash equal to latest block hash.</span>
        </div>
        <div>
          <Icon type="tool"/>
          <span style={blockText}>Block hash meets difficulty requirement.</span>
        </div>
        <div>
          <Icon type="calculator"/>
          <span style={blockText}>Block hash is correctly calculated.</span>
        </div>
      </div>

      <p className="step-p"> 
        Other peers on the network will be adding blocks to the blockchain, so new blocks need to be validated.
      </p>
    </div>
  );
};

export default Concept;


// WEBPACK FOOTER //
// ./src/steps/valid-block/concept.js